import { Injectable, Injector } from '@angular/core';
import { FireAlarmComponentDto } from '@authority-labs/api-interfaces';
import { Path } from '@authority-labs/enums';
import { CrudService } from '../../shared/services/crud/crud.service';

@Injectable({
  providedIn: 'root'
})
export class FireAlarmComponentsService extends CrudService<FireAlarmComponentDto> {
  constructor(injector: Injector) {
    super(injector, Path.FireAlarmComponents, FireAlarmComponentDto);
  }
}
